module.exports = __webpack_public_path__ + "img/1441225638.cb43d759.jpg";